import {
  isEqual
} from 'helpers';

export class Page {

  constructor(fields) {
    this.fields = fields;
  }

  mapToStandard() {

    return {
      id: this.fields.attributes?.id,
      title: this.fields.attributes?.title,
      content: this.fields.attributes?.body?.value,
      cmsPath: this.fields.attributes?.path?.alias,
      subPages: this.fields.attributes?.relationships
        .filter(rel => isEqual(rel.field, 'field_sub_pages'))
        .map(subPage => {
          return {
            subPageContent: subPage.subPageContent?.value
          };
        })
    };
  }
}
